import React from "react"
import EmpleadoPage from "../components/EmpleadoPage/EmpleadoPage"
import RoleGuard from "../components/Auth0/RoleGuard"

const Empleado = () => (
  <RoleGuard allowedRoles={["Empleado", "Admin"]}>
    <div
      className="d-flex"
      style={{ width: "100%", height: "100vh" }}
    >
      <div className="flex-grow-1">
        <EmpleadoPage />
      </div>
    </div>
  </RoleGuard>
)

export default Empleado
